module.exports = __webpack_public_path__ + "static/media/TickButton.fb86783b.svg";